export const dataStatus = {
  waiting: "WAITING",
  live: "LIVE",
  end: "END",
};

export function getStatus(votingStatus) {
  switch (votingStatus) {
    case "waiting-data":
      return dataStatus.waiting;
    case "in-progress":
      return dataStatus.live;
    case "finished":
      return dataStatus.end;
    default:
      return "";
  }
}

function populateData(currentVoting) {
  const currentStatus = getStatus(currentVoting.status);
  const item = document.querySelector(".js-info-scrutiny-time");
  const icon = document.querySelector(".js-info-scrutiny-icon");

  if (item === undefined || icon === undefined) {
    return;
  }

  if (currentStatus === dataStatus.waiting) {
    icon.classList.add("is-inactive");
    icon.classList.remove("active");
    item.innerHTML = item.dataset.waitingTime;
    return;
  }

  if (currentStatus === dataStatus.live) {
    const text = item.dataset.availableTime.replace(
      "#date",
      currentVoting.time
    );
    icon.classList.remove("is-inactive");
    icon.classList.add("active");
    item.innerHTML = text;
  }

  if (currentStatus === dataStatus.end) {
    icon.classList.add("is-inactive");
    icon.classList.remove("active");
    item.innerHTML = item.dataset.unavailableTime;
  }

  if (currentVoting.votesCountedPct > 0) {
    document.querySelector(".js-info-scrutiny-percentage").innerHTML = document
      .querySelector(".js-info-scrutiny-percentage")
      .dataset.availablePercentage.replace(
        "#percentage",
        currentVoting.votesCountedPct.toFixed(2).replaceAll(".", ",")
      );
  }

  if (currentVoting.votesPct > 0) {
    document.querySelector(".js-info-scrutiny-participation").innerHTML =
      document
        .querySelector(".js-info-scrutiny-participation")
        .dataset.availableParticipation.replace(
          "#participation",
          currentVoting.votesPct.toFixed(2).replaceAll(".", ",")
        );
  }
}

function drawInfoLive() {
  window.dataManager.getVoting().then((currentVoting) => {
    if (currentVoting) {
      populateData(currentVoting);
    }
  });
}

function init() {
  if (document.querySelector('[data-controller*="ac-info-live"]')) {
    drawInfoLive();
  }
}

export default init;
